module.exports = __webpack_public_path__ + "img/arrow-left.d5a54dec.svg";